module.exports = __webpack_public_path__ + "e8aca07cb474967461f273809d532f74.pdf";